import React from "react";
import { chakra, Flex } from "@chakra-ui/react";
import { langStore, translate } from "@noli/business";
import { APIOption } from "@noli/core";
import SchemaProperty from "@/components/Property/SchemaProperty";
import { WithClassName } from "@/types/base";
import { Editor_Words } from "@/utils/lang/editor";

const INegativePromptSwitch: React.FC<
  WithClassName<{
    value: boolean;
    onChange: (value: boolean, apiKey: string) => void;
  }>
> = ({ value, onChange, className }) => {
  const lang = langStore.tgt;
  return (
    <Flex flexDirection="column" mt="16px" className={className}>
      <Flex>
        <SchemaProperty
          identifier={`negative-prompt`}
          w="100%"
          py="4px"
          pr="4px"
          color="text.primary"
          lang={lang}
          apiKey={translate(Editor_Words["negative-prompt-input-title"], lang)}
          apiOption={new APIOption("bool", value)}
          value={value}
          setValue={() => onChange}
          fontSize="14px"
        />
      </Flex>
    </Flex>
  );
};

export const NegativePromptSwitch = chakra(INegativePromptSwitch);
